export default "__VITE_ASSET__CAK9xFTQ__"